import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LuMenu, LuX, LuUser, LuLogOut, LuSettings, LuBell, LuMapPin, LuCar, LuHistory, LuLogIn, LuUserPlus, LuUsers, LuHouse, LuTrophy, LuUsersRound, LuGift, LuMail, LuLightbulb } from 'react-icons/lu';
import logo from '../styles/images/logo-spotypark-2png.png';
import { useEffect, useState, useRef } from 'react';
import 'animate.css';
import '../styles/css/Header.css';
import { auth } from '../Firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

export default function Header() {
  const location  = useLocation();
  const navigate  = useNavigate();
  const [isLoggedIn,   setIsLoggedIn]   = useState(false);
  const [emailVerifie, setEmailVerifie] = useState(false);
  const [isAdminFull,  setIsAdminFull]  = useState(false);
  const [menuOpen,     setMenuOpen]     = useState(false); // ← état menu mobile

  // ── Ferme le menu à chaque changement de route ────────────────────────────
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const isProtectedRoute = (path) => {
    const protectedRoutes = ['/user', '/parrainage'];
    return protectedRoutes.some(route => path.startsWith(route));
  };

  useEffect(() => {
    const firestore   = getFirestore();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsLoggedIn(false);
        setEmailVerifie(false);
        setIsAdminFull(false);
        if (isProtectedRoute(location.pathname)) navigate('/');
        return;
      }
      setIsLoggedIn(true);
      try {
        const userSnap = await getDoc(doc(firestore, 'users', user.uid));
        if (!userSnap.exists()) return;
        const data = userSnap.data();
        if (data.role === 'admin') {
          setEmailVerifie(true);
          setIsAdminFull(true);
          return;
        }
        const verifie = user.emailVerified || data.emailVerifie === true;
        setEmailVerifie(verifie);
        if (!verifie && isProtectedRoute(location.pathname)) navigate('/login');
      } catch (err) {
        console.warn('Erreur header:', err);
        setEmailVerifie(false);
        setIsAdminFull(false);
      }
    });
    return () => unsubscribe();
  }, [location.pathname, navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsLoggedIn(false);
      setEmailVerifie(false);
      setIsAdminFull(false);
      setMenuOpen(false);
      navigate('/');
    } catch (error) {
      console.error('Erreur déconnexion:', error);
    }
  };

  const closeMenu = () => setMenuOpen(false);

  const activeStyle = {
    fontWeight: 'bold', textDecoration: 'underline',
    textDecorationThickness: '2px', textUnderlineOffset: '5px',
    color: '#07a993',
  };

  const badgeAdmin = (
    <span style={{
      fontSize: '0.65rem', background: '#dc3545',
      color: '#fff', padding: '2px 5px',
      borderRadius: '8px', marginLeft: '4px',
    }}>
      Admin
    </span>
  );

  useEffect(() => {
    const shakeLogo = document.querySelector('.navbar-brand');
    if (shakeLogo) shakeLogo.classList.add('animate__animated', 'animate__bounce');
  }, []);

  return (
    <header className="navbar navbar-expand-lg bg-white shadow-sm mb-5">
      <nav className="container-fluid">

        {/* Logo */}
        <Link to="/" >
          <img src={logo} alt="Logo spotypark"
            className="d-inline-block align-text-top"
            style={{ height: '17vh', maxHeight: '80px' }} />
        </Link>
        

        {/* Bouton hamburger */}
        <button className="btn btn-primary d-lg-none" type="button"
          onClick={() => setMenuOpen(true)}
          style={{ padding: '10px 14px' }}>
          <LuMenu size={24} />
        </button>

        {/* ══════════════════════════════════════════════════════════════
            MENU DESKTOP
        ══════════════════════════════════════════════════════════════ */}
        <div className="collapse navbar-collapse d-none d-lg-flex justify-content-center">
          <ul className="navbar-nav">

            <li className="nav-item mx-2">
              <Link to="/" className="nav-link text-gray-700"
                style={location.pathname === '/' ? activeStyle : {}}>
                Accueil <LuHouse size={20} />
              </Link>
            </li>

            {!isLoggedIn && (
              <li className="nav-item mx-2">
                <Link to="/inscription" className="nav-link text-gray-700"
                  style={location.pathname === '/inscription' ? activeStyle : {}}>
                  Inscription <LuUser size={20} />
                </Link>
              </li>
            )}

            <li className="nav-item mx-2">
              <Link to="/recompenses" className="nav-link text-gray-700"
                style={location.pathname === '/recompenses' ? activeStyle : {}}>
                Spotygifts <LuTrophy size={20} />
              </Link>
            </li>

            {isLoggedIn && emailVerifie && (
              <>
                <li className="nav-item mx-2">
                  <Link to="/user" className="nav-link"
                    style={location.pathname === '/user' ? activeStyle : {}}>
                    Mon compte <LuUser size={20} />
                  </Link>
                </li>

                <li className="nav-item mx-2">
                  <Link to="/parrainage" className="nav-link text-gray-700"
                    style={location.pathname === '/parrainage' ? activeStyle : {}}>
                    Parrainage <LuGift size={20} />
                  </Link>
                </li>

                {isAdminFull && (
                  <>
                    <li className="nav-item mx-2">
                      <Link to="/admin/messages" className="nav-link"
                        style={location.pathname === '/admin/messages' ? activeStyle : {}}>
                        <LuMail size={20} /> Messages {badgeAdmin}
                      </Link>
                    </li>
                    <li className="nav-item mx-2">
                      <Link to="/suggestions" className="nav-link"
                        style={location.pathname === '/suggestions' ? activeStyle : {}}>
                        <LuLightbulb size={20} /> Suggestions {badgeAdmin}
                      </Link>
                    </li>
                  </>
                )}
              </>
            )}

            {isLoggedIn && !emailVerifie && (
              <li className="nav-item mx-2 d-flex align-items-center">
                <span style={{
                  fontSize: '0.82rem', color: '#ffc107', fontWeight: 600,
                  border: '1px solid #ffc107', borderRadius: '6px', padding: '4px 10px',
                }}>
                  ⚠️ Email non vérifié
                </span>
              </li>
            )}

            <li className="nav-item mx-2">
              {isLoggedIn ? (
                <button onClick={handleLogout}
                  className="nav-link text-gray-700 border-0 bg-transparent"
                  style={{ cursor: 'pointer' }}>
                  Déconnexion <LuLogOut size={20} />
                </button>
              ) : (
                <Link to="/login" className="nav-link text-gray-700"
                  style={location.pathname === '/login' ? activeStyle : {}}>
                  Connexion <LuLogIn size={20} />
                </Link>
              )}
            </li>
          </ul>
        </div>

        {/* ══════════════════════════════════════════════════════════════
            MENU MOBILE — géré par React state, plus Bootstrap JS
        ══════════════════════════════════════════════════════════════ */}

        {/* Overlay sombre derrière le menu */}
        {menuOpen && (
          <div onClick={closeMenu} style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1040,
          }} />
        )}

        <div style={{
          position: 'fixed', top: 0, right: 0,
          width: '280px', height: '100vh',
          background: '#fff', zIndex: 1050,
          transform: menuOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.3s ease',
          overflowY: 'auto',
          boxShadow: '-4px 0 16px rgba(0,0,0,0.15)',
        }} className="d-lg-none">

          {/* Header du menu */}
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            <div className="d-flex align-items-center gap-2">
              <img src={logo} alt="Logo SpotyPark" style={{ height: '40px' }} />
              <span className="fw-bold">SpotyPark</span>
            </div>
            <button onClick={closeMenu}
              className="btn btn-sm btn-outline-secondary"
              style={{ padding: '6px 10px' }}>
              <LuX size={20} />
            </button>
          </div>

          {/* Liens */}
          <ul className="list-group list-group-flush">

            <li className="list-group-item p-0">
              <Link to="/" onClick={closeMenu}
                className="d-flex align-items-center p-3 text-decoration-none text-dark"
                style={location.pathname === '/' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                <LuHouse size={20} className="me-3" />
                <span className="fw-medium">Accueil</span>
              </Link>
            </li>

            {!isLoggedIn && (
              <li className="list-group-item p-0">
                <Link to="/inscription" onClick={closeMenu}
                  className="d-flex align-items-center p-3 text-decoration-none text-dark"
                  style={location.pathname === '/inscription' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                  <LuUserPlus size={20} className="me-3" />
                  <span className="fw-medium">Inscription</span>
                </Link>
              </li>
            )}

            <li className="list-group-item p-0">
              <Link to="/recompenses" onClick={closeMenu}
                className="d-flex align-items-center p-3 text-decoration-none text-dark"
                style={location.pathname === '/recompenses' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                <LuBell size={20} className="me-3" />
                <span className="fw-medium">Spotygifts</span>
              </Link>
            </li>

            {isLoggedIn && emailVerifie && (
              <>
                <li className="list-group-item p-0">
                  <Link to="/user" onClick={closeMenu}
                    className="d-flex align-items-center p-3 text-decoration-none text-dark"
                    style={location.pathname === '/user' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                    <i className="bi bi-person-fill me-3"></i>
                    <span className="fw-medium">Mon compte</span>
                  </Link>
                </li>

                <li className="list-group-item p-0">
                  <Link to="/parrainage" onClick={closeMenu}
                    className="d-flex align-items-center p-3 text-decoration-none text-dark"
                    style={location.pathname === '/parrainage' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                    <LuUsers size={20} className="me-3" />
                    <span className="fw-medium">Parrainage</span>
                  </Link>
                </li>

                {isAdminFull && (
                  <>
                    <li className="list-group-item p-0">
                      <Link to="/admin/messages" onClick={closeMenu}
                        className="d-flex align-items-center p-3 text-decoration-none text-dark"
                        style={location.pathname === '/admin/messages' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                        <span className="me-3" style={{ fontSize: '1.1rem' }}>✉️</span>
                        <span className="fw-medium">Messages</span>
                        {badgeAdmin}
                      </Link>
                    </li>

                    <li className="list-group-item p-0">
                      <Link to="/suggestions" onClick={closeMenu}
                        className="d-flex align-items-center p-3 text-decoration-none text-dark"
                        style={location.pathname === '/suggestions' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                        <span className="me-3" style={{ fontSize: '1.1rem' }}>💡</span>
                        <span className="fw-medium">Suggestions</span>
                        {badgeAdmin}
                      </Link>
                    </li>
                  </>
                )}
              </>
            )}

            {isLoggedIn && !emailVerifie && (
              <li className="list-group-item p-3">
                <div style={{
                  fontSize: '0.85rem', color: '#ffc107',
                  fontWeight: 600, padding: '8px',
                  border: '1px solid #ffc107', borderRadius: '6px',
                }}>
                  ⚠️ Vérifiez votre email pour accéder à toutes les fonctionnalités.
                </div>
              </li>
            )}

            <li className="list-group-item p-0">
              {isLoggedIn ? (
                <button onClick={handleLogout}
                  className="d-flex align-items-center p-3 w-100 border-0 bg-white text-start">
                  <LuLogOut size={20} className="me-3" />
                  <span className="fw-medium">Déconnexion</span>
                </button>
              ) : (
                <Link to="/login" onClick={closeMenu}
                  className="d-flex align-items-center p-3 text-decoration-none text-dark"
                  style={location.pathname === '/login' ? { backgroundColor: '#f8f9fa', color: '#07a993' } : {}}>
                  <LuLogIn size={20} className="me-3" />
                  <span className="fw-medium">Connexion</span>
                </Link>
              )}
            </li>
          </ul>

          {/* Pied de menu */}
          <div className="mt-4 p-3 border-top">
            {!isLoggedIn && (
              <Link to="/inscription" onClick={closeMenu}
                className="btn btn-primary w-100">
                S'inscrire gratuitement
              </Link>
            )}
            <p className="mt-3 mb-0 text-center text-muted small">
              © 2025 SpotyPark - Tous droits réservés
            </p>
          </div>
        </div>

      </nav>
    </header>
  );
}